import { SYSTEM_TIER_RATES_VALUES } from '../constants'
import { getActiveTierIndex } from '../hooks/useCommissionTiers'

// Рассчитывает вознаграждение для действующих партнеров
const getPartnerReward = (turnovers: { [code: string]: number } | null): number | null => {
  if (!turnovers) {
    return null
  }

  const entries = Object.entries(turnovers)

  if (entries.length === 0) {
    return null
  }

  // Определяем активный тир по ОБЩЕЙ сумме всех оборотов
  const totalTurnover = entries.reduce((sum, [, turnover]) => sum + turnover, 0)
  const activeIndex = getActiveTierIndex(totalTurnover)

  // Ниже порога — вознаграждения нет
  if (activeIndex === -1) {
    return 0
  }

  const total = entries.reduce((sum, [code, turnover]) => {
    const rates = SYSTEM_TIER_RATES_VALUES[code]

    if (!rates) {
      return sum
    }

    const ratePercent = rates[activeIndex]
    const numberRatePercent = ratePercent ? parseFloat(ratePercent) : 0

    return sum + turnover * (numberRatePercent / 100)
  }, 0)

  return total
}

export default getPartnerReward
